import {connect, Dispatch} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import SettingsMenu from './SettingsMenu';
import Action from '../../redux/Actions';
import {ModalStates} from '../../globals/Constants';
import ModalEventHandlersModel from '../../types/ModalEventHandlers';
import ReduxState from '../../types/ReduxState';
import Themeable from '../../types/Themeable';

const mapStateToProps = (state: ReduxState, ownProps: RouteComponentProps): RouteComponentProps & ISettingsMenuStateMappedProps => {
   return {
      history: ownProps.history,
      location: ownProps.location,
      match: ownProps.match,
      userId: state.currentUserId,
      themeName: state.themeName
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): ISettingsMenuStateDispatchProps => {
   return {
      setModalState: (modalState: ModalStates, modalEventHandlersModel: ModalEventHandlersModel) => {
         dispatch(Action.setModalState({modalState}, modalEventHandlersModel));
      }
   };
};

interface ISettingsMenuStateMappedProps extends Themeable {
   userId: string;
}

interface ISettingsMenuStateDispatchProps {
   setModalState(modalState: ModalStates, modalEventHandlersModel: ModalEventHandlersModel): void;
}

export type SettingsMenuProps = RouteComponentProps & ISettingsMenuStateMappedProps & ISettingsMenuStateDispatchProps;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SettingsMenu));
